<template>
    <div class="app-inner" id="sort">
        <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  @click="reback" style="margin-left:0">
                返回
            </div>
           <el-button type="primary" :loading="loading" class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
           @click="updataSort"
            >
                保存
           </el-button>
            </div>
               <div class="p-tit-c">
             <div class="businessList-filter">
                <div class="businessList-filter-list flex align-cen">
                        <div class="fl-le flex align-cen">
          <div class="label">发布渠道：</div>
           <el-select v-model="value" placeholder="请选择【一级】"
           @change="classSelect"
                clearable
                >
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.label"
                      >
                    </el-option>
           </el-select>
            <el-select v-model="value1" placeholder="请选择【二级】"
             @change="classSelect1"
                clearable
                 style="margin-left:20px"
                >
                    <el-option
                      v-for="item in options1"
                      :key="item.value"
                      :label="item.label"
                      :value="item.label"
                      >
                    </el-option>
           </el-select>
        </div>
                </div>
             </div>
               </div>
                    <div class="businessList-container flex">
                      <div class="businessList-container-silder" style="width:50%">
                         <el-carousel trigger="click" height="360px"
    :interval="5000"
    :autoplay="true"
    >
                  <el-carousel-item v-for="(item,index) in tableData" :key="index">
                      <div class="banner-list">
                          <img :src="item.picUrl" alt="" style="height:360px;width:100%" v-if="getResourceType(item.picUrl) == 'img'">
                            <VideoPlay
                             v-show="true"
                            :videoUrl="item.picUrl"
                            :height="460"
                            :autoplay="true"
                            :controls="false"
                            :loop="true"
                            :muted="false"
                            preload="auto"
                            :showPlay="true"
                            :playWidth="96"
                            zoom="cover"
                            v-if="getResourceType(item.picUrl) == 'video'"
                          />
                      </div>
                      <div class="banner-description">
                        <div class="name" v-if="getResourceType(item.picUrl) != 'video'">{{item.name}}</div>
                      <div class="description" v-if="getResourceType(item.picUrl) != 'video'">{{item.description}}</div>
                      <div class="btn" @click="openBannerView(item)"
                      :style="getResourceType(item.picUrl) == 'video' ? {'margin-top':'100px'} : ''"
                      >立即查看</div>
                      </div>
                  </el-carousel-item>
                </el-carousel>
                      </div>
            <div class="businessList-container-table mft" style="width:50%">
                           <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          border
          id='mytable'
          :row-class-name="tableRowClassName"
          :header-cell-style="{background:'#f7f8fa',color:'#333'}"
        >
          <el-table-column
        v-for="(item, index) in col"
        :key="`col_${index}`"
        :prop="item.prop"
        :label="item.label"
        :width="item.prop == 'sort'?'100px':''"
        align="center"
      >
         <!-- 自定义渲染模版 -->
          <template slot-scope="scope">
             <!-- 当列key为 sort 时，渲染一个手柄icon -->
          <template v-if="item.prop =='sort'">
            <div class="handle_move">
              <i  class="icon-al-arrows-alt"  style="font-size:22px"/>
            </div>
          </template>
           <template v-else-if="item.prop == 'picUrl'">
            <img :src="scope.row[`${item.prop}`]" alt="" style="width:129px;height:48px" v-if="getResourceType(scope.row.picUrl) == 'img'">
             <VideoPlay
                v-show="true"
                :videoUrl="scope.row[`${item.prop}`]"
                :height="48"
                :width="129"
                :autoplay="false"
                :controls="false"
                :loop="false"
                :muted="false"
                preload="auto"
                :showPlay="false"
                :playWidth="96"
                zoom="cover"
                v-if="getResourceType(scope.row.picUrl) == 'video'"
              />
          </template>
          <template v-else-if="item.prop == 'channelFirst'">
          <span>{{scope.row[`${item.prop}`]}} - {{scope.row[`${item.prop1}`]}}</span>
          </template>
          <template v-else>
            <span>{{scope.row[`${item.prop}`]}}</span>
          </template>
          </template>
          </el-table-column>
         </el-table>
            <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
            </div>
                    </div> 
    </div>
</template>
<script>
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
import Sortable from "sortablejs";
import { websiteBanner,updateSort} from "@/api/index/index"  //轮播图列表、轮播图排序
import VideoPlay from '@/components/VideoPlay'
export default {
    name:'bannerSort',
    components:{
      paginaTion,
      VideoPlay
    },
    data() {
        return {
            oldIndex: null,
            newIndex: null,
            tableData:[
            ],
            loading:false,
            value:'和隆优化官网',
            value1:'官网首页',
            currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            totalCount:0,
             col: [
          { label: "缩略图", prop: "picUrl" },
          { label: "名称", prop: "name" },
          { label: "发布渠道", prop: "channelFirst",prop1:'channelSecond' },
          { label: "操作", prop: "sort" }
        ],
           options:[
              {
               value: '1',
               label: '和隆优化官网'
              },
              {
               value: '2',
               label: '和隆软件官网'
              },
               {
               value: '3',
               label: '微信小程序'
              }
              ],
              options1:[
                 {
                              value: '1',
                              label: '官网首页'
                              },
                              {
                              value: '2',
                              label: '课程首页-网页端'
                              }
              ],
        }
    },
 activated(){
  this.gethisInfo()
},
    created() {
    },
    mounted(){
    },
    methods: {
       // 打开轮播图详情页
        openBannerView(data){
             this.$bus.$emit("isBanner", true);
             if(data.particularType == '1'){
                 
                let path=data.particulars
               window.open(path,'_black')
             }else{
                  const newurl = this.$router.resolve({name: 'bannerDetail', query: {id: data.id}})
                    window.open(newurl.href,'_blank')
             }
        },
       getResourceType(url) {
         const extension = url.split('.').pop().toLowerCase(); 
         if (extension === 'jpg' || extension === 'jpeg' || extension === 'png' || extension === 'gif') 
         { return 'img'; }
          else if (extension === 'mp4' || extension === 'avi' || extension === 'mov' || extension === 'wmv') 
         { return 'video'; } 
         else { return 'unknown'; } 
         },
      // 保存
      updataSort(){
        if(!this.value) return this.$util.Notifi('请选择一级发布渠道','error','fa-exclamation-circle')
        if(!this.value1) return this.$util.Notifi('请选择二级发布渠道','error','fa-exclamation-circle')
        this.loading = true
          updateSort(this.tableData)
        .then(res => {
          this.loading = false
          if(res.code == 0){
            this.$util.Notifi('排序成功','success','fa-check'); 
            this.gethisInfo()
          }
        })
        .catch(err =>{this.loading = false;this.$util.Notifi('排序失败','error','fa-exclamation-circle')})
         
      },
      // 自组件触发
      emitFun (val,val1){
       if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.gethisInfo()
      },
      // 获取列表
       gethisInfo(){
         let params = {
          id:'',
          name:'',
          createTimeStart:'',
          createTimeEnd:'',
          channelFirst:this.value,
          channelSecond:this.value1,
          state:'1',
          size:this.PageSize,
          current:this.currentPage,
          orderBy:'sort'
         }
         websiteBanner(params)
         .then(res => {
          this.tableData = res.data.records
          this.totalCount =res.data.total
          this.init()
         })
         .catch(err => {})
       },
        	init(){
		// 1. 获取拖拽元素的父元素
		// 因为使用的element的table 所以可直接获取tbody
		let el =  document.querySelector(".el-table__body-wrapper tbody");
		let _this = this;	
		// 2. 创建并配置相关参数
		var sortable = new Sortable(el, {			
			// 只有按住手柄才能进行拖拽
            handle:'.handle_move',
			// 行拖拽，所以该值设置为行class
			draggable:'.el-table__row', // 允许拖拽的项目类名
            
			// 因为拖拽过程中不尽兴位置调整，所以就要记录拖拽行初始位置以及目标位置
			// 拖拽中 回调函数
			 onMove(customEvent) {
	          // 禁止在拖拽过程中交换位置
	          // 可将初始位置及目标位置进行记录
	          _this.oldIndex = customEvent.dragged.rowIndex; //  初始位置
	          _this.newIndex = customEvent.related.rowIndex; // 目标位置
	          return false;  // 不进行交换
	          // 返回值有三个
	          // return false; — for cancel
	          // return -1; — insert before target
	          // return 1; — insert after target
	        },
			
			// 拖拽结束，调整位置
			onEnd() {
               
	          // 在拖拽结束后，获取初始及目标位置
	          const { newIndex, oldIndex } = _this;
	          const currRow = _this.tableData.splice(oldIndex, 1)[0];
	          _this.tableData.splice(newIndex, 0, currRow);
	          // 拖拽完成，初始位置及目标位置重置
	          _this.newIndex = null;
	          _this.oldIndex = null;
	        },
		})
	},
    // 目标位置高亮
	// 给目标行 添加高亮样式
	 tableRowClassName({ row, rowIndex }) {
      if (rowIndex === this.newIndex) {
        return "warning-row";
      }
      return "";
    },
        // 返回
         reback(){
             this.$router.push("/HomeWebsite")
        },
          // 筛选
           classSelect1(){
            this.currentPage = 1
             this.gethisInfo()

           },
        // 筛选
           classSelect(){
            this.currentPage = 1
              if(this.value == '和隆优化官网' || this.value == '和隆软件官网'){
                        this.options1 = [
                              {
                              value: '1',
                              label: '官网首页'
                              },
                              {
                              value: '2',
                              label: '课程首页-网页端'
                              }
                        ]
                        this.value1 = ''
                      }else if(this.value == '微信小程序'){
                        this.options1 = [ 
                          {
                            value: '1',
                              label: '获客小程序首页'
                          }
                        ]
                            this.value1 = ''
                      }else{
                        this.value1 = ''
                        this.options1 = []
                      }
             this.gethisInfo()
           
        },

    },
}
</script>
<style lang="scss" scoped>
#sort{
  margin-bottom: 60px;
}
.handle_move {
  cursor: move;
}
.businessList-container-silder{
  margin-top: 20px;
  position: relative;
  .el-carousel{
    width: 99%;
  }
  .banner-description{
    position: absolute;
    top:64px;
    left:10%;
    .name{
        font-size: 21px;
    color: #181818;
    line-height: 48px;
    margin-bottom: 15px;
    opacity: 1;
    min-height: 48px;
    }
    .description{
       height: 60px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    font-size: 13px;
    color: #181818;
    line-height: 30px;
    margin-bottom: 20px;
    opacity: 1;

    }
      .btn{
                     width: 108px;
                    cursor: pointer;
                    border: none;
                   height: 42px;
                   line-height: 42px;
                    font-size: 13px;
                    text-align: center;
                    vertical-align: middle;
                    background-color: #2893f1;
                    border-radius: 1px;
                    margin-right: 20px;
                    padding: 0px 0;
                    color: #fff;
                    a{
                        color: #fff;
                    }
                }
  }
}
</style>